import React from 'react';
import {Grid, Paper, Typography} from "@mui/material";
import '../../../style/homepage/homepage.scss';
import neuroleap from '../images/neuroleap.png';
import fenwickspeechtherapy from '../images/fenwickspeechtherapy.png';

import {MdOutlineFacebook} from "react-icons/md";
import {SlSocialLinkedin} from 'react-icons/sl';
import {RiTwitterXLine} from 'react-icons/ri';
import {TbBrandThreads} from "react-icons/tb";
import {BsShare} from 'react-icons/bs';
import { useTranslation } from 'react-i18next';

const styles = {
    header: {
        fontFamily: 'Montserrat',
        fontSize: '0.95rem',
        fontWeight: '600',
        color: '#1C1B1F',
        marginTop: '1.25rem',
        marginBottom: '0.75rem',
    },
    aboutHook: {
        fontWeight: '700',
        color: '#6750A4',
    },
    aboutParagraph: {
        fontFamily: 'Montserrat',
        fontSize: '0.85rem',
        fontWeight: '400',
        lineHeight: '1.6',
        color: '#49454F',
    },
    sponsors: {
        fontFamily: 'Montserrat',
        fontSize: '0.8rem',
        fontWeight: '500',
        padding: '0.4rem 0.8rem',
        backgroundColor: '#E8DEF8',
        border: 'none',
        color: '#6750A4',
        margin: '0.25rem',
        borderRadius: '20px',
        textAlign: 'center',
    }
}

function AboutUs() {
    const { t } = useTranslation();
    return (
        <div style={{ padding: '0.5rem' }}>
            <Grid container direction={'column'}>
                {/* About Us */}
                <Grid item>
                    <Typography style={{
                        fontFamily: 'Montserrat',
                        fontSize: '1.1rem',
                        fontWeight: '600',
                        color: '#1C1B1F',
                        marginBottom: '0.75rem',
                        paddingBottom: '0.75rem',
                        borderBottom: '2px solid #E8DEF8',
                    }}>
                        {t('About Us')}
                    </Typography>
                </Grid>
                <Grid item container justifyContent={'center'} alignItems={'center'}>
                    <Grid item xs={8}>
                        <Typography style={styles.aboutParagraph}>
                            <span style={styles.aboutHook}>
                                {t('Vivid Kids ')}
                            </span>
{t('is a non-profit that striving to raise the public awareness for children with Occupational Therapy needs.')}
                        </Typography>
                        <a
                            href="https://vividkids.org"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                                display: 'inline-block',
                                marginTop: '1rem',
                                padding: '0.5rem 1.25rem',
                                backgroundColor: '#6750A4',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontSize: '0.85rem',
                                fontWeight: '600',
                                borderRadius: '20px',
                                textDecoration: 'none',
                                transition: 'background-color 0.2s ease',
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#4A3880'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#6750A4'}
                        >
                            {t('Visit VividKids.org')}
                        </a>
                    </Grid>
                </Grid>
                {/* Sponsors' Products */}
                <Grid item>
                    <Typography style={styles.header}>
                        {t("Sponsors' Products")}
                    </Typography>
                </Grid>
                <Grid item container direction={'row'} wrap={'nowrap'} justifyContent={'center'} alignItems={'center'}>
                    <Grid item xs={2}>
                        <img src={neuroleap} alt={'sponsors'} className={'sponsorsImage'}/>
                    </Grid>
                    <Grid item container direction={'column'} spacing={3} xs={5}>
                        <Grid item>
                            <Paper variant={'outlined'} square>
                                <Typography style={styles.button}>
                                    {'Neuroleap ONE'}
                                </Typography>
                            </Paper>
                        </Grid>
                        <Grid item>
                            <Paper variant={'outlined'} square>
                                <Typography style={styles.button}>
                                    {'OT Screener ||'}
                                </Typography>
                            </Paper>
                        </Grid>
                    </Grid>
                </Grid>
                {/* Partners */}
                <Grid item>
                    <Typography style={styles.header}>
                        {t('Partners')}
                    </Typography>
                </Grid>
                <Grid item container direction={'row'}>
                    <Grid item xs={5}>
                        <a href={'https://www.hslu.ch/en/'}>

                            <img src="lucerne-university.png"
                                 alt={'Hochschule Lucerne University of Applied Sciences and Arts'}
                                 className={'partnersImage'}/>
                        </a>
                    </Grid>
                    <Grid item xs={5}>
                        <a href={'https://fenwickspeechtherapy.com/'}>
                            <img src="fenwick-speech-therapy.png" alt={'Fenwick Speech Therapy'}
                                 className={'partnersImage'}/>
                        </a>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography style={styles.header}>
                        {t('Share')}
                    </Typography>
                </Grid>
                {/* Share links */}
                <Grid item container direction={'row'} justifyContent={'center'}>
                    <Grid item>
                        <div className="socials">
                            <a href={'https://twitter.com/leapneuro?lang=en'}><RiTwitterXLine size={35}/></a>
                            <a href={'https://www.threads.net/@neuroleap1'}><TbBrandThreads size={35}/></a>
                            <a href={'https://m.facebook.com/Neuro-Leap-Corp-278266009350133/'}>
                                <MdOutlineFacebook size={35}/>
                            </a>
                            <a href={'https://www.linkedin.com/company/neuroleap-corp/'}>
                                <SlSocialLinkedin size={35}/>
                            </a>
                            <a href={window.location.pathname}><BsShare size={35}/></a>
                        </div>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    )
}

export default AboutUs;
